import { SectionHeader } from "./SectionHeader";
import { useI18n } from "@/i18n";

export function Process() {
  const { t } = useI18n();

  return (
    <section id="process" className="section-y">
      <div className="container-page">
        <SectionHeader eyebrow={t.process.eyebrow} title={t.process.title} />

        <ol className="mt-12 grid gap-px overflow-hidden rounded-lg border border-border bg-border md:grid-cols-2 lg:grid-cols-4">
          {t.process.steps.map((step) => (
            <li key={step.n} className="bg-card p-7">
              <span className="font-display text-3xl text-accent tabular-nums">{step.n}</span>
              <h3 className="mt-4 text-[0.98rem] font-semibold tracking-tight text-foreground">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
